import { render } from "./EstadoActualView.vue?vue&type=template&id=24c60ce5"
import script from "./EstadoActualView.vue?vue&type=script&lang=js"
export * from "./EstadoActualView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__